
import { useState } from 'react';

export default function ProjectsGallerySection() {
  const images = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/b51428005534d0bb3b21512157badb1d.jpeg'
    },
    {
      id: 2,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/2ede017c41d724ad5d7a7800b6f1c958.jpeg'
    },
    {
      id: 3,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/cc877d396237a06639d0b0645195c70c.jpeg'
    },
    {
      id: 4,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/ca3fb965b804ab29f3955399b8679132.jpeg'
    },
    {
      id: 5,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/bc687a0dc703e2886114812db38d5c46.jpeg'
    },
    {
      id: 6,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/9f7ca73fdc3bf4061cdd97f7b406a821.jpeg'
    },
    {
      id: 7,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/5a1f751c34b37d4cae321493cc48ab69.jpeg'
    },
    {
      id: 8,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/d8315dea53376d92c3c02ecf4ad7337f.jpeg'
    },
    {
      id: 9,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/b096e49d4b74502f4db72b245461bd98.jpeg'
    },
    {
      id: 10,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/5905de5661b05924306af39b88629a4d.jpeg'
    },
    {
      id: 11,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/344e3c45456f8d13c4ffa5c558e4d623.jpeg'
    },
    {
      id: 12,
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/4bcf6de7a834b01f9f856a3a42e60b93.jpeg'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Galeria de Imagens
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-3xl mx-auto leading-relaxed">
            Conheça alguns dos nossos projetos que exemplificam nossa excelência em design e execução técnica.
          </p>
        </div>

        {/* Images Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((item) => (
            <div 
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={`Projeto ${item.id}`}
                  className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
